import React, { useRef, useState } from "react";
import PreOrderInfo from "../../../BookModule.module.css";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import ViewIcon from "../../BookTabs/ViewIcon.png";
import { Link, useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import { AxiosInstance } from "../../../../../../../axios";
import { R_PER_PAGE } from "../../../../../../../labels";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useEffect } from "react";
import PreOrderBook from "./PreOrderBook";
import moment from "moment";
import Loader from "../../../../../Loader";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { clearBookFilters, setBookFilters } from "../../../../../../../redux/purchaseBookFilterSlice";
export default function CreatePreOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToPreviousScreen = () => {
    dispatch(clearBookFilters());
    navigate(-1); // Navigate back by one step in the history
  };
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  const [listErrors, setListErrors] = useState({});
  // List data load table
  let page = R_PER_PAGE;
  let filterSearch = [];
  let filterAuthor = [];
  let filterPublisher = [];
  let filtervisible_to_user = [];
  let filterCategory = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterMedium = [];

  const filterRef_author = useRef(null);
  const filterRef_publisher = useRef(null);
  const filterRef_visible_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_subject = useRef(null);
  const filterRef_medium = useRef(null);

  const preorderBookNameRef = useRef([React.createRef()]);
  const preorderpcountRef = useRef([React.createRef()]);
  const preorderexpectedDateRef = useRef([React.createRef()]);
  const filterRef_mrp = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const txtBSearch_course = useRef(null); //search icon
  const txtBSearch_sub = useRef(null);
  // use state
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [updateListData, setUpdateListData] = useState();
  const [originalListData, setOriginalListData] = useState();

  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [courseIds, setCourseIds] = useState([]);

  const [subjectIds, setSubjectIds] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [auData, setAuData] = useState([]);
  const [pubData, setPubData] = useState([]);
  const [author_name, setAuthor_name] = useState([]);
  const [publisher_name, setPublisher_name] = useState([]);
  const [visible_to_user, setVisible_to_user] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [isOpen, setIsOpen] = useState({
    author: false,
    publisher: false,
    visible_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    price: false
  });

  const [preOrderItem, setPreOrderItem] = useState([]);

  const [selectedBookItem, setSelectedBookItem] = useState([]);

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const filters = useSelector((state) => state.listBookFilter);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: ""
  })
  const handleChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  }
  useEffect(() => {
    setAuthor_name(filters.author || []);
    setPublisher_name(filters.publisher || []);
    setVisible_to_user(filters.visibleToUser || []);
    setCategory_on(filters.category || []);
    setCourse_on(filters.course || []);
    setSubject_on(filters.subject || []);
    setMedium_on(filters.medium || []);
    setSearchTerm(filters.searchTerm || []);
    setInitialfields(filters.price || {})
    setIsFiltersInitialized(true); // Mark filters as initialized

    const allFilters = [
      ...(filters.author || []),
      ...(filters.publisher || []),
      ...(filters.visibleToUser || []),
      ...(filters.category || []),
      ...(filters.course || []),
      ...(filters.subject || []),
      ...(filters.medium || []),
      ...(filters.price?.fromDate && filters.price?.toDate
        ? [
          {
            name: `${filters.price.fromDate} - ${filters.price.toDate}`,
            type: 'price',
          },
        ]
        : []),
      ...(typeof filters.searchTerm === "string" &&
        filters.searchTerm.trim() !== ""
        ? [{ name: filters.searchTerm, type: "search" }]
        : []),
    ];
    setUpdateChipData(allFilters);
  }, [filters]);

  useEffect(() => {
    if (
      isFiltersInitialized &&
      filters &&
      Object.keys(filters).some((key) => filters[key]?.length > 0)
    ) {
      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (isFiltersInitialized && filters) {
      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_author.current &&
        !filterRef_author.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "author"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "author"
            );
            setAuthor_name(updatedAuthor);
          } else {
            setAuthor_name([]);
          }
          setIsOpen((prev) => ({ ...prev, author: false }));
        }
      } if (filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            // alert("1")
            const [fromDate, toDate] = updatedAuthor[0].name.split(" - ").map((val) => val.trim());

            setInitialfields({ fromDate, toDate });
          } else {
            // alert("2")

            setInitialfields({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }
      if (
        filterRef_publisher.current &&
        !filterRef_publisher.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "publisher"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "publisher"
            );
            setPublisher_name(updatedCategory);
          } else {
            setPublisher_name([]);
          }
          setIsOpen((prev) => ({ ...prev, publisher: false }));
        }
      }
      if (
        filterRef_visible_to_user.current &&
        !filterRef_visible_to_user.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "visible_to_user"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "visible_to_user"
            );
            setVisible_to_user(updatedCategory);
          } else {
            setVisible_to_user([]);
          }
          setIsOpen((prev) => ({ ...prev, visible_to_user: false }));
        }
      }
      if (
        filterRef_category.current &&
        !filterRef_category.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_course.current &&
        !filterRef_course.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    author_name,
    publisher_name,
    visible_to_user,
    category_on,
    course_on,
    subject_on,
    medium_on,
    initialfields
  ]);
  useEffect(() => {
    filterAuthor = author_name;
  }, [author_name]);

  useEffect(() => {
    filterPublisher = publisher_name;
  }, [publisher_name]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterCourse = course_on;
  }, [course_on]);
  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);

  useEffect(() => {
    filtervisible_to_user = visible_to_user;
  }, [visible_to_user]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);



  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
    loadListdata();
  }, []);

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "author") {
      if (checked) {
        setAuthor_name([
          ...author_name,
          { id: value, name: name, type: "author" },
        ]);
      } else {
        setAuthor_name(author_name.filter((item) => item.id !== value));
      }
    } else if (typename === "publisher") {
      if (checked) {
        setPublisher_name([
          ...publisher_name,
          { id: value, name: name, type: "publisher" },
        ]);
      } else {
        setPublisher_name(publisher_name.filter((item) => item.id !== value));
      }
    } else if (typename === "visible_to_user") {
      if (checked) {
        setVisible_to_user([
          { id: value, name: name, type: "visible_to_user" },
        ]);
      } else {
        setVisible_to_user(visible_to_user.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([ ...category_on, { id: value, name: name, type: "category" }]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([ ...course_on, { id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([  ...subject_on,{ id: value, name: name, type: "subject" }]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    }
  };
  function loadListdata() {
    let tempAuthor = [];
    let tempPublisher = [];
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempVuser = [];
    // Convert string IDs to numbers using parseInt or unary plus
    author_name.map((obj) => {
      tempAuthor.push(Number(obj.id));
    });
    publisher_name.map((obj) => {
      tempPublisher.push(Number(obj.id));
    });
    category_on.map((obj) => {
      tempCate.push(Number(obj.id));
    });
    course_on.map((obj) => {
      tempCourse.push(Number(obj.id));
    });
    subject_on.map((obj) => {
      tempSubj.push(Number(obj.id));
    });
    medium_on.map((obj) => {
      tempMedium.push(Number(obj.id));
    });
    visible_to_user.map((obj) => {
      tempVuser.push(Number(obj.id));
    });
    let statusFilter = {
      search: searchTerm.length > 0 ? searchTerm : "",
      author_id: author_name.length > 0 ? tempAuthor : "",
      publisher_id: publisher_name.length > 0 ? tempPublisher : "",
      category_id: category_on.length > 0 ? tempCate : "",
      group_course_id: course_on.length > 0 ? tempCourse : "",
      subject_id: subject_on.length > 0 ? tempSubj : "",
      medium: medium_on.length > 0 ? tempMedium : "",
      is_set: 0,
      visible_user: visible_to_user.length > 0 ? tempVuser : "",
      select_set_list: 2,
      is_ebook: "",
      is_free_book: "",
      is_combo_offer: "",
      start_range_mrp: initialfields.fromDate || "",
      end_range_mrp: initialfields.toDate || "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          const FD = res.data.data;
          const serialNumberAddedData = FD.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setOriginalListData(FD);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);

          setIsLoading(false);
        } else {
          setUpdateListData([]);
          setPreOrderItem([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenAuthorIds = new Set();
      const seenPublisherIds = new Set();
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const auDatas = data
        .filter((es) => {
          if (seenAuthorIds.has(es.author_id)) {
            return false; // Skip this entry if the author_id is already seen
          } else {
            seenAuthorIds.add(es.author_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          author_name: es.author,
          author_id: es.author_id,
        }));

      setAuData(auDatas);
      const PublishDatas = data
        .filter((es) => {
          if (seenPublisherIds.has(es.publisher_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenPublisherIds.add(es.publisher_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          publisher_name: es.publisher,
          publisher_id: es.publisher_id,
        }));

      setPubData(PublishDatas);
      const CourseDatas = data
        .filter((es) => {
          if (!es.group_course_name || seenCourseIds.has(es.group_course_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);
      const SubjectDatas = data
        .filter((es) => {
          if (!es.subject_name || seenSubjectIds.has(es.subject_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);
    }
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    if (initialfields.fromDate || initialfields.toDate) {
      tempArr.push({
        name: ` ${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
        value: `MRP`,
        type: "price"
      });
    }
    filterAuthor.map((obj) => {
      tempArr.push(obj);
    });
    filtervisible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterPublisher.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  function updateStateData() {
    filterAuthor = author_name;
    filterPublisher = publisher_name;
    filtervisible_to_user = visible_to_user;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterMedium = medium_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "author") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        author: false,
      });
    }
    else if (name === "price") {
      loadChipdata();
      // let tempArr = [];
      // if (initialfields.fromDate || initialfields.toDate) {
      //   tempArr.push({
      //     name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
      //     value: `MRP`,
      //     type: "price"
      //   });
      // }
      // setUpdateChipData(tempArr); loadListdata();
      setIsOpen({
        ...isOpen,
        price: false,
      });
    } else if (name === "publisher") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        publisher: false,
      });
    } else if (name === "visible_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        visible_to_user: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    }
  };

  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      author: false,
      publisher: false,
      visible_to_user: false,
      category: false,
      course: false,
      subject: false,
      medium: false,
    });
    if (name === "author") {
      setAuthor_name([]);
      filterAuthor = [];
    } else if (name === "publisher") {
      setPublisher_name([]);
      filterPublisher = [];
    } else if (name === "visible_to_user") {
      setVisible_to_user([]);
      filtervisible_to_user = [];
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "course") {
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "price") {
      setInitialfields({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleAllClear = () => {
    setAuthor_name([]);
    setPublisher_name([]);
    setVisible_to_user([]);
    setInitialfields({});
    setSubject_on([]);
    setMedium_on([]);
    setCourse_on([]);
    setCategory_on([]);
    setSearchTerm([]);
    setUpdateChipData([]);
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "author") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        author: !prevState.author, // Toggle the value
        visible_to_user: false,
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
      }));
      setAuthor_name(updateChipData.filter((ui) => ui.type === "author"));
    } else if (boxName === "publisher") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: false,
        publisher: !prevState.publisher, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setPublisher_name(updateChipData.filter((ui) => ui.type === "publisher"));
    } else if (boxName === "visible_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: !prevState.visible_to_user, // Toggle the value
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setVisible_to_user(
        updateChipData.filter((ui) => ui.type === "visible_to_user")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    }
  };

  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "publisher") {
      setPublisher_name(
        publisher_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterPublisher = publisher_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "price") {
      setInitialfields({ fromDate: "", toDate: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "price")
      );
      shouldReloadChipData = false;
    } else if (chipToDelete.type === "visible_to_user") {
      setVisible_to_user(
        visible_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filtervisible_to_user = visible_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "course") {
      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };

  const handlechangePreOrder = (e, bookId, bookName) => {
    const { value, name, checked } = e.target;
    if (checked) {
      setSelectedBookItem((prevState) => [...prevState, bookId]);
      preorderBookNameRef.current.push(React.createRef());
      preorderpcountRef.current.push(React.createRef());
      preorderexpectedDateRef.current.push(React.createRef());
      // Calculate the next ID based on the current preOrderItem list
      setPreOrderItem((prevState) => {
        const nextId =
          prevState.length > 0
            ? Math.max(...prevState.map((item) => item.id)) + 1
            : 1;
        const newItem = {
          id: nextId,
          book_id: bookId,
          book_title: bookName,
          book_pre_order_count: "",
          book_expected_date: "",
        };
        return [...prevState, newItem];
      });
    } else {
      // If unchecked, remove the item from selectedBookItem and preOrderItem
      setSelectedBookItem((prevState) =>
        prevState.filter((id) => id !== bookId)
      );
      setPreOrderItem((prevState) =>
        prevState.filter((item) => item.book_id !== bookId)
      );
    }
  };

  // const preOrderChange = (e, bookIds, Ids, indexValue) => {
  //   const { name, value } = e.target;
  //   setPreOrderItem((prevState) => {
  //     return prevState.map((q) => {
  //       if (q.id == Ids && q.book_id == bookIds) {
  //         return { ...q, [name]: value };
  //       }
  //       return q;
  //     });
  //   });
  //   setListErrors((prevState) => ({
  //     ...prevState,
  //     [`${name}_error_${indexValue}`]: "",
  //   }));
  // };

  const preOrderChange = (e, bookIds, Ids, indexValue) => {
    const { name, value } = e.target;
    const regex = /^[1-9]\d{0,4}$/;

    // Validation Logic
    if (regex.test(value)) {
      // Update preOrderItem when the value is valid
      if (regex.test(value)) {
        // Update preOrderItem only if the value is valid
        setPreOrderItem((prevState) =>
          prevState.map((q) =>
            q.id === Ids && q.book_id === bookIds
              ? {
                ...q,
                [name]: value, // Ensure it's a valid integer
              }
              : q
          )
        );
      }

      // Clear the corresponding error
      setListErrors((prevState) => ({
        ...prevState,
        [`${name}_error_${indexValue}`]: "",
      }));
    } else {
      // Update preOrderItem only if the value is valid
      setPreOrderItem((prevState) =>
        prevState.map((q) =>
          q.id === Ids && q.book_id === bookIds
            ? {
              ...q,
              [name]: value, // Ensure it's a valid integer
            }
            : q
        )
      );

      // Set error messages based on conditions
      if (value <= 0) {
        setListErrors((prevState) => ({
          ...prevState,
          [`${name}_error_${indexValue}`]: `${name === "book_pre_order_count" ? "Value" : name
            } cannot be negative`,
        }));
      } else if (value.startsWith("0") && value.length > 1) {
        setListErrors((prevState) => ({
          ...prevState,
          [`${name}_error_${indexValue}`]: "Leading zeros are not allowed",
        }));
      } else if (!Number.isInteger(Number(value))) {
        setListErrors((prevState) => ({
          ...prevState,
          [`${name}_error_${indexValue}`]: "Only whole numbers are allowed",
        }));
      } else if (value.length > 5) {
        setListErrors((prevState) => ({
          ...prevState,
          [`${name}_error_${indexValue}`]: `${name === "book_pre_order_count" ? "Value" : name
            } cannot exceed 5 digits`,
        }));
      } else {
        setListErrors((prevState) => ({
          ...prevState,
          [`${name}_error_${indexValue}`]: ``,
        }));
        // setListErrors((prevState) => ({
        //   ...prevState,
        //   [`${name}_error_${indexValue}`]: `Please enter a valid number between 1 and 100000`,
        // }));
      }
    }
  };

  const handlePreOrderChangeDate = (date, id, name, indesx, bookids) => {
    const dateEYD = moment(date).format("DD/MM/YYYY");
    setPreOrderItem((prevState) => {
      return prevState.map((q) => {
        if (q.id == id && q.book_id == bookids) {
          return { ...q, [name]: dateEYD };
        }
        return q;
      });
    });
    setListErrors((prevState) => ({
      ...prevState,
      [`${name}_error_${indesx}`]: "",
    }));
  };

  const validatePreOrder = (data) => {
    const errors = {};
    if (data.length > 0) {
      data.forEach((OB, index) => {
        if (!OB.book_title) {
          errors[`book_title_error_${index}`] = "Book Name is required";
        }
        if (!OB.book_pre_order_count) {
          errors[`book_pre_order_count_error_${index}`] =
            "Book preorder count is required";
        } else {
          const orderCount = Number(OB.book_pre_order_count);
          if (isNaN(orderCount) || orderCount <= 0) {
            errors[`book_pre_order_count_error_${index}`] =
              "Value cannot be negative";
          }
          if (!Number.isInteger(Number(orderCount))) {
            errors[`book_pre_order_count_error_${index}`] =
              "Only whole numbers are allowed";
          }
          const orderCountStr = OB.book_pre_order_count.toString();

          if (orderCountStr.startsWith("0") && orderCountStr.length > 1) {
            errors[`book_pre_order_count_error_${index}`] =
              "Leading zeros are not allowed";
          }
          if (orderCount.toString().length > 5) {
            errors[`book_pre_order_count_error_${index}`] =
              "Value cannot exceed 5 digits";
          }
        }
        if (!OB.book_expected_date) {
          errors[`book_expected_date_error_${index}`] =
            "Book expected date is required";
        }
      });
    }

    validatePreOrderFocus(data);
    return errors;
  };

  const validatePreOrderFocus = (data) => {
    const errors = {};
    if (data.length > 0) {
      data.map((OB, index) => {
        let updateOrder = { ...OB };
        if (!OB.book_title) {
          preorderBookNameRef.current[index].current.focus();
        }
        if (!OB.book_pre_order_count) {
          preorderpcountRef.current[index].current.focus();
        }
        if (!OB.book_expected_date) {
          preorderexpectedDateRef.current[index].current.setFocus();
        }
        return updateOrder;
      });
    }
    return errors;
  };

  const handleSubmit = () => {
    const errorss = validatePreOrder(preOrderItem);
    if (Object.keys(errorss).length === 0) {
      const dataI = {
        id: "",
        preorder_books: preOrderItem.map((er) => ({
          book_id: er.book_id,
          order_count: parseInt(er.book_pre_order_count),
          expected_date: moment(er.book_expected_date, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          created_dt: moment().format("YYYY-MM-DD"),
          created_by: userid,
        })),
      };
      setIsLoading(true);
      AxiosInstance.post("/api/book/create_preorder", dataI)
        .then((res) => {
          if (res.data.status) {
            setIsLoading(false);
            toast.success(res.data.message);
            navigateToPreviousScreen();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setListErrors(errorss);
    }
  };

  const handleView = (id) => {
    dispatch(
      setBookFilters({
        author: author_name,
        publisher: publisher_name,
        visibleToUser: visible_to_user,
        category: category_on,
        course: course_on,
        subject: subject_on,
        medium: medium_on,
        searchTerm: searchTerm,
        price: initialfields,
      })
    );
    navigate(`/viewIndividualBook/${id}`);
  };
  const uniqueAuthors = Array.from(
    new Map(
      originalListData
        ?.filter((item) => item.author_id !== 0) // Remove items with author_id = 0
        .map((item) => [item.author_id, item])
    ).values()
  );
  const uniquePublisher = Array.from(
    new Map(
      originalListData
        ?.filter((item) => item.publisher_id !== 0) // Remove items with publisher_id = 0
        .map((item) => [item.publisher_id, item])
    ).values()
  );

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathHeader BathDet global_container">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">Create New Pre-Orders</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                Back to Books
              </Link>
            </li>
            <li
              className={`ListBtnItems ${preOrderItem.length === 0 && " disabled_btn"
                } `}
            >
              <Link
                to={"javascript:void(0)"}
                onClick={preOrderItem.length === 0 ? () => { } : handleSubmit}
                className="primaryButton"
              >
                Save Pre-Orders
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={PreOrderInfo.preorderContainer}>
            <legend className="w-auto mb-0">Individual Books</legend>
            <div className="row mx-0">
              <div className="col-md-3 col-12 px-0 mb-3">
                <div class={PreOrderInfo.searchInputSec}>
                  <input
                    ref={txtBSearch}
                    className={`${PreOrderInfo.searchInput} w-100`}
                    type="text"
                    placeholder="Search by Book Name"
                    name="search_book_title"
                    onKeyDown={handleSearch}
                  />
                  <Search
                    onClick={handleSearchFocus}
                    className={`${PreOrderInfo.ListsearchIcon}`}
                  />
                </div>
              </div>
            </div>
            {updateChipData?.length > 0 ? (
              <div className="row mx-0">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      return (
                        <ListItem key={index}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={PreOrderInfo.BoldTyText}>
                                  {data.type === "price" ? `Price: ${data.name}` : data.name}
                                </span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0 mt-2">
              <div
                className={`col-md-12 ${PreOrderInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
              >
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      <th id="th" className={PreOrderInfo.tableThPadding}></th>
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className="textHead_th"
                        >
                          Book Name
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_author}
                      >
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className="textHead_th"
                        >
                          Author
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${author_name.length > 0 || isOpen.author
                            ? PreOrderInfo.active_icons_book
                            : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "author")}
                        >
                          filter_list
                        </span>
                        {isOpen.author && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {uniqueAuthors.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.author}
                                        value={el.author_id}
                                        id={el.author}
                                        checked={author_name.some((element) => {
                                          if (element.id == el.author_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.author,
                                            "author"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.author}
                                      >
                                        {el.author}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("author")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        author_name.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("author")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                        
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_publisher}
                      >
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className="textHead_th"
                        >
                          Publisher
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${publisher_name.length > 0 || isOpen.publisher
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } }`} // Change here
                          onClick={(e) => handleFilter(e, "publisher")}
                        >
                          filter_list
                        </span>
                        {isOpen.publisher && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {uniquePublisher.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.publisher}
                                        value={el.publisher_id}
                                        id={el.publisher}
                                        checked={publisher_name.some(
                                          (element) => {
                                            if (element.id == el.publisher_id) {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.publisher,
                                            "publisher"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.publisher}
                                      >
                                        {el.publisher}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("publisher")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        publisher_name.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("publisher")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_visible_to_user}
                      >
                        <div class={PreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            class="textHead_th"
                          >
                            Visible <br /> to Users
                          </span>
                          <div class={PreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "is_visible")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${visible_to_user.length > 0 ||
                                isOpen.visible_to_user
                                ? PreOrderInfo.active_icons_book
                                : ""
                                } `} // Change here
                              onClick={(e) =>
                                handleFilter(e, "visible_to_user")
                              }
                            >
                              filter_list
                            </span>
                          </div>
                        </div>
                        {isOpen.visible_to_user && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Visible to User :Yes"}
                                      value={1}
                                      checked={visible_to_user.some(
                                        (element) => {
                                          if (element.id == 1) {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"visible_to_user_Yes"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "visible_to_user",
                                          "visible_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"visible_to_user_Yes"}
                                    >
                                      Yes
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Visible to User :No"}
                                      value={0}
                                      checked={visible_to_user.some(
                                        (element) => {
                                          if (element.id == 0) {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"visible_to_user_No"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "visible_to_user",
                                          "visible_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"visible_to_user_No"}
                                    >
                                      No
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() =>
                                        handleClear("visible_to_user")
                                      }
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        visible_to_user.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("visible_to_user")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_category}
                      >
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${category_on.length > 0 || isOpen.category
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } `} // Change here
                          onClick={(e) => handleFilter(e, "category")}
                        >
                          filter_list
                        </span>

                        {isOpen.category && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {categoryId.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.name}
                                        value={el.id}
                                        id={el.name}
                                        checked={category_on.some((element) => {
                                          if (element.id == el.id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.name,
                                            "category"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.name}
                                      >
                                        {el.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("category")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        category_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("category")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                           
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_course}
                      >
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className="textHead_th"
                        >
                          Course
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${course_on.length > 0 || isOpen.course
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } }`} // Change here
                          onClick={(e) => handleFilter(e, "course")}
                        >
                          filter_list
                        </span>
                        {isOpen.course && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${PreOrderInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${PreOrderInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by course"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "course")
                                      }
                                      ref={txtBSearch_course}
                                    />
                                    <Search
                                      onClick={(e) =>
                                        handleFilterSearchFocus("course")
                                      }
                                      className={`${PreOrderInfo.ListsearchIcon}`}
                                    />
                                  </li>
                                  {courseIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.course_name}
                                        value={el.course_id}
                                        id={el.course_name}
                                        checked={course_on.some((element) => {
                                          if (element.id == el.course_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.course_name,
                                            "course"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.course_name}
                                      >
                                        {el.course_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("course")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        course_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("course")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_subject}
                      >
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className="textHead_th"
                        >
                          Subject
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${subject_on.length > 0 || isOpen.subject
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } `} // Change here
                          onClick={(e) => handleFilter(e, "subject")}
                        >
                          filter_list
                        </span>
                        {isOpen.subject && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${PreOrderInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${PreOrderInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by subject"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "subject")
                                      }
                                      ref={txtBSearch_sub}
                                    />
                                    <Search
                                      onClick={() =>
                                        handleFilterSearchFocus("subject")
                                      }
                                      className={`${PreOrderInfo.ListsearchIcon}`}
                                    />
                                  </li>
                                  {subjectIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.subject_name}
                                        value={el.subject_id}
                                        id={el.subject_name}
                                        checked={subject_on.some((element) => {
                                          if (element.id == el.subject_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.subject_name,
                                            "subject"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.subject_name}
                                      >
                                        {el.subject_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("subject")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        subject_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("subject")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={PreOrderInfo.tableThPadding}
                        ref={filterRef_medium}
                      >
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${medium_on.length > 0 || isOpen.medium
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } `} // Change here
                          onClick={(e) => handleFilter(e, "medium")}
                        >
                          filter_list
                        </span>
                        {isOpen.medium && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Tamil"}
                                      value={"0"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "0") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_tamil"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_tamil"}
                                    >
                                      Tamil
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"English"}
                                      value={"1"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "1") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_english"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_english"}
                                    >
                                      English
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Both"}
                                      value={"2"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "2") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Both"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Both"}
                                    >
                                      Both
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("medium")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        medium_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("medium")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th id="th" className={PreOrderInfo.tableThPadding} ref={filterRef_mrp}>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className="textHead_th"
                        >
                          MRP
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${(initialfields.fromDate || initialfields.toDate || isOpen.price)
                            ? PreOrderInfo.active_icons_book
                            : ""
                            } `} // Change here
                          onClick={(e) => handleFilter(e, "price")}
                        >
                          filter_list
                        </span>
                        {isOpen.price === true && (
                          <div className="filterBoxs p-1 mt-3">
                            <div className="row ">
                              <div className="col-md-12">
                                <div>
                                  <div>
                                    <label for="bookName" class="form-label confirm_value ">
                                      From
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="fromDate"
                                    name="fromDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the from price"
                                    value={initialfields.fromDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div>
                                  <div>
                                    <label for="bookName" class="form-label confirm_value ">
                                      To
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="toDate"
                                    name="toDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the to price"
                                    value={initialfields.toDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                {/* <div class="form-check">
                                                                      <MultiRangeSlider
                                                                        handleChangeFilter={handleChangeFilter}
                                                                        ranges={ranges}
                                                                      />
                                                                    </div> */}
                              </div>
                            </div>
                            <hr />
                            <div className="row mt-3">
                              <div className="col-md-4  col-4 col-sm-4">
                                <span
                                  className="clearFilter ms-2 "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClear("price")}
                                >
                                  Clear
                                </span>
                              </div>
                              <div className="col-md-8  col-8 col-sm-8">
                                <button
                                  className="FilterButton"
                                  onClick={() => handleApplyFilter("price")}
                                >
                                  Apply Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </th>
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className="textHead_th"
                        >
                          Offer %
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <div class={PreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            class="textHead_th"
                          >
                            Final <br /> Price
                          </span>
                          <div class={PreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "finalPrice")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>{" "}
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <div class={PreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "stock_count")}
                            class="textHead_th"
                          >
                            Stock <br /> Count
                          </span>
                          <div class={PreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "stock_count")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th id="th" className={PreOrderInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentData?.map((kl, ind) => (
                        <tr key={ind}>
                          <td>
                            <input
                              class={`${PreOrderInfo.checkBox_input}`}
                              type="checkbox"
                              name={"book_pre_order"}
                              id={"book_pre_order"}
                              value={kl.id}
                              onChange={(e) =>
                                handlechangePreOrder(e, kl.id, kl.book_title)
                              }
                            />
                          </td>
                          <td id="td">{kl.serialNumber}</td>
                          <td id="td">
                            <span
                              title={kl.book_title}
                              className={PreOrderInfo.ellipsisText}
                            >
                              {kl.book_title}
                            </span>
                          </td>
                          <td id="td">
                            {" "}
                            <span
                              title={kl.author}
                              className={PreOrderInfo.ellipsisText}
                            >
                              {kl.author}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={kl.publisher}
                              className={PreOrderInfo.ellipsisText}
                            >
                              {kl.publisher}
                            </span>
                          </td>
                          <td id="td">{kl.is_visible ? "Yes" : "No"}</td>
                          <td id="td">
                            {kl.category_name ? kl.category_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={kl.group_course_name}
                              className={PreOrderInfo.ellipsisText}
                            >
                              {kl.group_course_name
                                ? kl.group_course_name
                                : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={kl.subject_name}
                              className={PreOrderInfo.ellipsisText}
                            >
                              {kl.subject_name ? kl.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{kl.medium ? kl.medium : "_"}</td>
                          <td id="td">{kl.price ? kl.price : "0"}</td>
                          <td id="td">
                            {kl.offer_percentage ? kl.offer_percentage : "0"}
                          </td>
                          <td id="td">{kl.finalPrice ? kl.finalPrice : "0"}</td>
                          <td id="td">
                            {kl.stock_count == 0
                              ? kl.stock_count
                              : kl.stock_count || "_"}
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={PreOrderInfo.cursor_pointer}
                              alt="view icon"
                              onClick={(e) => handleView(kl.id)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${PreOrderInfo.prev_buttonViewAllbook} ${PreOrderInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={totalPages == 0 || currentPage === totalPages}
              />
            </div>
          </fieldset>
          {preOrderItem.map((item, index) => (
            <PreOrderBook
              key={item.id}
              index={index}
              bookErrors={listErrors}
              length={preOrderItem.length}
              record={item}
              preOrderChange={preOrderChange}
              handlePreOrderChangeDate={handlePreOrderChangeDate}
              preorderBookNameRef={preorderBookNameRef.current[index]}
              preorderexpectedDateRef={preorderexpectedDateRef.current[index]}
              preorderpcountRef={preorderpcountRef.current[index]}
            />
          ))}
        </div>
      </div>
      <div className="row mt-3 mb-4 mx-0">
        <div className="col-md-12 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                Back to Books
              </Link>
            </li>
            <li
              className={`ListBtnItems ${preOrderItem.length === 0 && " disabled_btn"
                } `}
            >
              <Link
                to={"javascript:void(0)"}
                onClick={preOrderItem.length === 0 ? () => { } : handleSubmit}
                className="primaryButton"
              >
                Save Pre-Orders
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
